(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/extends', 'lodash', './getGuid', './levels'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/extends'), require('lodash'), require('./getGuid'), require('./levels'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global._extends, global.lodash, global.getGuid, global.levels);
    global.notificationsDuck = mod.exports;
  }
})(this, function (exports, _extends2, _lodash, _getGuid, _levels) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.DISMISS_NOTIFICATION = exports.ADD_NOTIFICATION = undefined;
  exports.notifyError = notifyError;
  exports.notifyInfo = notifyInfo;
  exports.notifySuccess = notifySuccess;
  exports.notifyWarn = notifyWarn;
  exports.dismissNotification = dismissNotification;
  exports.reducer = reducer;

  var _extends3 = _interopRequireDefault(_extends2);

  var _lodash2 = _interopRequireDefault(_lodash);

  var _getGuid2 = _interopRequireDefault(_getGuid);

  var _levels2 = _interopRequireDefault(_levels);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var ADD_NOTIFICATION = exports.ADD_NOTIFICATION = 'portal/notifications/ADD';
  var DISMISS_NOTIFICATION = exports.DISMISS_NOTIFICATION = 'portal/notifications/DISMISS';

  function notifyError(message) {
    return {
      type: ADD_NOTIFICATION,
      message: message,
      notificationType: _levels2.default.error
    };
  }
  function notifyInfo(message) {
    return {
      type: ADD_NOTIFICATION,
      message: message,
      notificationType: _levels2.default.info
    };
  }
  function notifySuccess(message) {
    return {
      type: ADD_NOTIFICATION,
      message: message,
      notificationType: _levels2.default.success
    };
  }
  function notifyWarn(message) {
    return {
      type: ADD_NOTIFICATION,
      message: message,
      notificationType: _levels2.default.warn
    };
  }
  function dismissNotification(id) {
    return { type: DISMISS_NOTIFICATION, id: id };
  }
  var initialState = { list: [] };
  function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
      case ADD_NOTIFICATION:
        {
          var list = state.list || [];
          return (0, _extends3.default)({}, state, {
            list: [].concat(list, [{
              id: (0, _getGuid2.default)(),
              message: action.message,
              level: action.notificationType
            }])
          });
        }
      case DISMISS_NOTIFICATION:
        {
          var _list = state.list;

          var i = _lodash2.default.findIndex(_list, { id: action.id });
          _lodash2.default.pullAt(_list, i);
          return { list: _list };
        }
      default:
        return state;
    }
  }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/Notifications/notifications.duck.js
// module id = 1877
// module chunks = 1